<template>
<div id="pt401" class="pt401" v-cloak>
    <breadcrumb :decriptPage="$t('common.labels.memberRegistration')"></breadcrumb>
    <div>
        <div class="itemTitle">
            <h2>{{$t('pt401.labels.title2')}}</h2>
        </div>
        <div class="section-inner">
            <h3 class="sectionTitle">{{$t('pt401.labels.title')}}</h3>
            <p class="memberCompInfo">{{$t('pt401.labels.dicription')}}<br>{{$t('pt401.labels.dicription2')}}</p>
            <div v-html="descriptionInfo['1']"/>
            <div class="memberCompBtn">
                <a v-if="syoninFlg == 0" class="btnSubmit" name="to_mypagetop" @click="buy_step2()" :title="$t('common.labels.myPgage')">{{$t('pt401.labels.toMyPageTop')}}</a>
                <a v-else class="btnSubmit" name="to_pagetop" @click="buy_step3()" :title="$t('common.labels.homePage')">{{$t('pt401.labels.toPageTop')}}</a>
            </div>
            <div v-if="fromCart == '1'" class="memberCompBtn"><a class="btnSubmit" @click="buy_step1()" >{{$t('pt401.labels.value')}}</a></div>
            <div >
                <span hidden id="kokyakuCd" class="kokyakuCd">{{pt401Request.kokyakuCd}}</span>
                <span hidden id="eigyokyoNo" class="eigyokyoNo">{{pt401Request.unicoEigyokyoNo}}</span>
                <span hidden id="mail" class="mail">{{pt401Request.mail}}</span>
                <span hidden id="cognitionSelect" class="cognitionSelect">{{pt401Request.analysisNm09}}</span>
                <span hidden id="cognitionLineDtlValue1" class="cognitionLineDtlValue1">{{pt401Request.unicoCognitionDtlValue1}}</span>
                <span hidden id="cognitionLineDtlValue2" class="cognitionLineDtlValue2">{{pt401Request.unicoCognitionDtlValue2}}</span><span hidden id="gyosyu" class="gyosyu">{{pt401Request.analysisNm10}}</span>
                <span hidden id="nm1" class="nm1">{{pt401Request.nm1}}</span>
                <span hidden id="nm2" class="nm2">{{pt401Request.nm2}}</span>
                <span hidden id="kana1" class="kana1">{{pt401Request.kana1}}</span>
                <span hidden id="kana2" class="kana2">{{pt401Request.kana2}}</span>
                <span hidden id="zip" class="zip">{{pt401Request.zip}}</span>
                <span hidden id="kenNm" class="kenNm">{{pt401Request.kenNm}}</span>
                <span hidden id="addr1" class="addr1">{{pt401Request.addr1}}</span>
                <span hidden id="addr2" class="addr2">{{pt401Request.addr2}}</span>
                <span hidden id="addr3" class="addr3">{{pt401Request.addr3}}</span>
                <span hidden id="tel1" class="tel1">{{pt401Request.tel1}}</span>
                <span hidden id="fax" class="fax">{{pt401Request.fax}}</span>
                <span hidden id="unicoTantoushaNm1" class="unicoTantoushaNm1">{{pt401Request.unicoTantoNm1}}</span>
                <span hidden id="unicoTantoushaKana1" class="unicoTantoushaKana1">{{pt401Request.unicoTantoKana1}}</span>
                <span hidden id="unicoTantoushaTel1" class="unicoTantoushaTel">{{pt401Request.unicoTantoTel1}}</span>
                <span hidden id="unicoTantoushaNm2" class="unicoTantoushaNm2">{{pt401Request.unicoTantoNm2}}</span>
                <span hidden id="unicoTantoushaKana2" class="unicoTantoushaKana2">{{pt401Request.unicoTantoKana2}}</span>
                <span hidden id="unicoTantoushaTel2" class="unicoTantoushaTe2">{{pt401Request.unicoTantoTel2}}</span>
                <span hidden id="unicoTantoushaNm2" class="unicoTantoushaNm3">{{pt401Request.unicoTantoNm3}}</span>
                <span hidden id="unicoTantoushaKana3" class="unicoTantoushaKana3">{{pt401Request.unicoTantoKana3}}</span>
                <span hidden id="unicoTantoushaTel3" class="unicoTantoushaTe3">{{pt401Request.unicoTantoTel3}}</span>
                <span hidden v-if="pt401Request.newsMailRcvFlg == 0" id="newsMailRcvFlg_0" class="newsMailRcvFlg_0">{{$t('pt400.labels.doNotWant')}}</span>
                <span hidden v-if="pt401Request.newsMailRcvFlg == 1" id="newsMailRcvFlg_1" class="newsMailRcvFlg_1">{{$t('pt400.labels.toWish')}}</span>
                <span hidden v-if="pt401Request.dmFlg == 0" id="dmNoFlg_0" class="dmNoFlg_0">{{$t('pt400.labels.doNotWant')}}</span>
                <span hidden v-if="pt401Request.dmFlg == 1" id="dmNoFlg_1" class="dmNoFlg_1">{{$t('pt400.labels.toWish')}}</span>
                <span hidden v-if="pt401Request.flierNgFlg == 0" id="flierNgFlg_0" class="flierNgFlg_0">{{$t('pt400.labels.doNotWant')}}</span>
                <span hidden v-if="pt401Request.flierNgFlg == 1" id="flierNgFlg_1" class="flierNgFlg_1">{{$t('pt400.labels.toWish')}}</span>
                <span hidden id="teikyubi" class="teikyubi">{{pt401Request.yobiStr6}}</span>
                <span hidden id="eigyojikan" class="eigyojikan">{{pt401Request.unicoEigyojikanFrom}} ～ {{pt401Request.unicoEigyojikanTo}}</span>
                <span hidden v-if="pt401Request.unicoReuseBox == 0" id="reuseBox_0" class="reuseBox_0">{{$t('pt400.labels.radioNg')}}</span>
                <span hidden v-if="pt401Request.unicoReuseBox == 1" id="reuseBox_1" class="hidden reuseBox_1">{{$t('pt400.labels.radioOk')}}</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import Loading from 'vue-loading-overlay';
import EventBus from 'assets/js/eventBus';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    /* 
    * Name of component
    */
    name: "PT401MemberInfoCompleteParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    /* 
    * Get data from parent component
    */
    components:
    {
        Loading,
        EventBus,
        Breadcrumb
        
    },
    data() {
        return {
            isLoading: false,
            listIdErr:[],
            pt401MemberInfo:{},
            SiteConstants: SiteConstants,
            descriptionInfo:null,
            fromCart:null,
            site: "",
            syoninFlg: 0,
            pt401Request:{}
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt401MemberInfo = _this.ptInitData;
            _this.descriptionInfo = _this.ptInitData.descriptionInfo;
            _this.syoninFlg = _this.ptInitData.syoninFlg;
            const pt406RequestStr = sessionStorage.getItem('pt406Request');
            const pt400RequestStr = sessionStorage.getItem('pt400Request');
            if (pt406RequestStr) {
                _this.pt406reqmodel = JSON.parse(pt406RequestStr);
                sessionStorage.removeItem('pt406Request');
                 _this.pt401Request = Object.assign({}, _this.ptInitData.reqModel,_this.pt406reqmodel);
            }else if(pt400RequestStr){
                _this.pt400reqmodel = JSON.parse(pt400RequestStr);
                sessionStorage.removeItem('pt400Request');
                _this.pt401Request = Object.assign({}, _this.ptInitData.reqModel,_this.pt400reqmodel);
            }
           
        }else{
            // eslint-disable-next-line
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT401 + _this.$UrlConstants.DO_INIT).then(function(response) {
                _this.pt401MemberInfo = response.data;
                _this.descriptionInfo = response.data.descriptionInfo;
                _this.syoninFlg = response.data.syoninFlg;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    methods: {
        buy_step1: function() {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 19}});
        },
        buy_step2: function() {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 81}});
        },
        buy_step3: function() {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 1}});
        }
    },
    /*
    * Excute code after an instance is created
    */
    created: function(){
         var _this = this;
        // Get data from params and query
        var paramData = _this.$route.query;
        if(Object.keys(paramData).length > 0){
            if(!common.isNullItem(paramData.fromCart))
                _this.fromCart = paramData.fromCart;
        }
    }
}
</script>